<div class="tags-component">
  <app-table
    (addNewItem)="addNewTag()"
    (sortColumn)="sortColumn($event)"
    (filterColumn)="getTagsFilteredByName($event)"
    (toggleActiveList)="toggleActiveList($event)"
    (showItemDetails)="showItemDetails($event)"
    (showEditModal)="showEditModal($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
    (pageChanged)="onPageChanged($event)"
    [tableData]="tableData"
    [isLoading]="loading"
  >
  </app-table>
  <app-loading-spinner class="spinner" *ngIf="loading"></app-loading-spinner>
</div>
